import classNames from "classnames";
import React from "react";
import { Option } from "web/react/components/select/types";
import styles from "./multi-column-option.css";

export interface MultiColumnOptionProps {
    isSelected: boolean;
    option: Option;
    onClick: () => void;
}

export default function MultiColumnOption({
    isSelected,
    option,
    onClick,
}: MultiColumnOptionProps): JSX.Element {
    const nColumns = option.text.length;

    let optionText: JSX.Element = (
        <>
            {option.text.map((text, index) => {
                return (
                    <div className={styles.optionText} key={`${text}_${index}`}>
                        {text}
                    </div>
                );
            })}
        </>
    );

    return (
        <div
            onClick={onClick}
            className={classNames(
                styles.option,
                { [styles.centered]: nColumns === 1 },
                { [styles.selected]: isSelected }
            )}
        >
            {optionText}
        </div>
    );
}
